import axios from "@/api/axios";

const login = async (credentials) => {
  const response = await axios.post("/auth/login", credentials);

  const data = response.data?.data;

  if (data?.token) {
    localStorage.setItem("admin_token", data.token);
  }

  if (data?.user) {
    localStorage.setItem("admin_user", JSON.stringify(data.user));
  }

  return response;
};

const logout = () => {
  localStorage.removeItem("admin_token");
  localStorage.removeItem("admin_user");
};

const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem("admin_user"));
  } catch {
    return null;
  }
};

const isAuthenticated = () => {
  return !!localStorage.getItem("admin_token");
};

const getToken = () => {
  return localStorage.getItem("admin_token") || null;
};

export default {
  login,
  logout,
  getUser,
  isAuthenticated,
  getToken,
};
